import React from "react";
import Rating from "@material-ui/lab/Rating";
import {
  makeStyles,
  Theme,
  createStyles,
  withStyles,
  useTheme,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import buttonStyle from "../../assets/jss/material-dashboard-pro-react/components/buttonStyle";
import { toast } from "react-toastify";

import * as api from "core-module/services/api";
import OptionItem from "../../common/components/SurveyModal/OptionItem";
import Button from "../../common/components/CustomButtons/Button";
import ExistingRating from "../../common/components/SurveyModal/ExistingRating";

const StyledRating = withStyles({
  icon: {
    fontSize: "2rem",
  },
  iconFilled: {
    color: "rgb(255, 180, 0)",
  },
  iconHover: {
    color: "rgb(255, 180, 0)",
  },
})(Rating);

const useStyles = makeStyles((theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 250,
      maxWidth: 400,
    },
    root: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      padding: 10,
      "& > * + *": {
        marginTop: theme.spacing(1),
      },
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        padding: 0,
      },
    },
    guideText1: {
      [theme.breakpoints.down("xs")]: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
      },
    },
    guideText2: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
      },
    },
    ...buttonStyle,
    textField: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
  })
);
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function CustomizedRatings(props) {
  const [value, setValue] = React.useState(0);
  const { switchModalState, user, ratingOptions, existingRating } = props;
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [comment, setComment] = React.useState("");
  const classes = useStyles();
  const handleChange = (index) => {
    setSelectedOptions((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  // React.useEffect(() => {
  //     switchModalState();
  // }, [switchModalState, user]);

  const postRating = async () => {
    if (value > 0) {
      // change rating_options to string
      const ratingOptionsString = selectedOptions.join(" ");
      api
        .post(`user.${user}/ratingsurvey`, {
          rate: value,
          rate_options: ratingOptionsString,
          comment: comment,
        })
        .then((res) => {
          if (res?.success != false) {
            toast.success("Thank you for taking the time to rate us!");
            switchModalState();
          } else {
            toast.error(
              "An error occurred while submitting your rating. Please try again later."
            );
          }
        })
        .catch((error) => {
          toast.error(
            "An error occurred while submitting your rating. Please try again later."
          );
          console.log(error);
        });
    }
  };
  return (
    <div>
      <div>
        {existingRating && Object.keys(existingRating).length > 0 && (
        <ExistingRating existingRating={existingRating} />
        )}
      </div>
      <div className={classes.root}>
        <p className={classes.guideText1}>Not at all likely</p>
        <StyledRating
          value={value}
          precision={1}
          max={10}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          size="medium"
        />
        <p className={classes.guideText2}>Extremely likely</p>
      </div>
      {value !== 0 && (
        <p>In what areas can we improve your experience with MCSnet?</p>
      )}
      <div style={{ display: "flex", width: "100%", flexWrap: "wrap" }}>
        {value !== 0 &&
          ratingOptions.map((option) => (
            <OptionItem
              key={option.id}
              item={option}
              isClicked={selectedOptions.includes(option[0])}
              onClick={() => handleChange(option[0])}
            />
          ))}
      </div>
      <div>
        {value !== 0 && (
          <div>
            <h4>Please leave us a comment to provide further details on how we can improve.</h4>
            <TextField
              id="comment"
              name="comment"
              label="Your Comment"
              multiline
              rows={10}
              variant="outlined"
              className={classes.textField}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
        )}
      </div>
      <div>
        <Button className={classes.primaryLightBlue} onClick={postRating}>
          Submit
        </Button>
      </div>
    </div>
  );
}

export default CustomizedRatings;
